import React, { Component, createRef, useRef } from "react";
import * as API from "./api.js";
import "./style.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Redirect, withRouter } from "react-router-dom";
import { ActivityPopup } from './ReusableComponents/ActivityPopup.js';
import TableView from "./ReusableComponents/TableView/TableView.js";
import { getFlightTime } from "./AeroGCSEnterprise/Flights/Flights.js";
import { BreadCrumbs } from "./ReusableComponents/BreadCrumbs.js";
import dateFormat from 'dateformat';
import Button from "./ReusableComponents/Button/Button.js";
import { GCS_FEATURES, getActiveTeam, getFeaturesPermissions } from "./Teams/index.js";
import { Popup, addUserAnalytic, updateOutTime } from "./ReusableComponents/reusableFunctions.js";
import { AnimatedModal } from './ReusableComponents/AnimatedModal.js';
import flightReplay from "./replayVideo.svg";
import lockIcon from './userAuth/assets/lock.svg'
import eyeIcon from './userAuth/assets/eye.svg'
import eyeOffIcon from './userAuth/assets/eye-off.svg'
import closeBtn from "./icons/close.png"
import DroneErrorLogsBtn from "./ReusableComponents/ErrorLogsBtn.js";
import LoaderComponent from "./ReusableComponents/LoaderComponent.js";
import SearchHeader from './ReusableComponents/SearchHeader/SearchHeader.js';
import DateTimePicker from "./AeroGCSEnterprise/Components/FlightsFilter/DateTimePicker.js";
import Cookies from "universal-cookie";
import Select from "react-dropdown-select";
import { ReactComponent as EditIcon } from './icons/hardwareEditIcon.svg';
import { connect } from "react-redux";
import InMaintenanceIcon from './InMaintenanceIcon.svg';
import Calender from "./assets/Calender.svg"
import CreateSelect from "./ReusableComponents/CreateSelect.js";
const cookies = new Cookies();

let otpInterval = null

const mapStateToProps = (state) => ({
  activeProfile: state.profile,
});

class DrnMgmtDroneDetails extends Component {
  state = {
    user: {},
    type: "",
    deleteRedirect: false,
    drone: {},
    model: {},
    isDroneMaintenanceModeEnablePopup: false,
    sidebarMode: this.props.location.state
      ? this.props.location.state.sidebarMode
      : "shrunk",
    showUnregisterDronePopup: false,
    addLeaseDronePopUp: false,
    usersCustomers: [],
    selectedCustomer: '',
    selectedCustomerName: '',
    lease: [],
    edit: false,
    editLease: '',
    minDate: new Date(),
    lease_drone: false,
    leaseActivityPopup: false,
    droneRentEdit: false,
    rentAmount: 0,
    isLoading: true,
    filter: {
      searchString: undefined,
      fromDateTime: undefined,
      toDateTime: undefined,
      orderBy: undefined,
      orderType: undefined,
      pageSize: 15,
      pageNumber: 1,
    },

    activityPopup: undefined,
    permissions: undefined,
    deleteData: undefined,
    outId: "",
    activityPopup: undefined,
    deleteFlightLogs: false,
    droneDataDeleteOtpPopup: false,
    errorOtp: '',
    showOtp: false,
    otpTimer: ``,
    otpTimerUIN: '',
    timeOutFlag: false,
    verifyOtpAndDeleteData: false,
    otp: '',
    droneDelete: false,
    loading: true,
    occuredError: [],
    crashErrors: [],
    medianErrorCount: 0,
    selectedPilot: null,
    selectedPilotName: null,
    pilots: [],
    droneUINEditPopup: false,
    droneUIN: '',
    Otp: '',
    otpModal: false,
    sendOTPOnMobile: false,
    showSendOTPbtn: true,
    resendOtp: false,
    phone: '',
    deleteDroneOtpVerifyModal: false,
    otpSent: false,
    datePicker: false,
  };

  closeActivityPopup = () => {
    this.setState((state) => ({
      ...state,
      activityPopup: undefined,
      deleteData: undefined,
      deleteFlightLogs: false,
      errorOtp: '',
      showOtp: false,
      timeOutFlag: false,
      verifyOtpAndDeleteData: false,
      otp: '',
      Otp: '',
      otpTimer: '',
      otpTimerUIN: '',
      droneDelete: false,
      sendOTPOnMobile: false,
    }))
    if (this.state.deleteRedirect) window.history.back();
  }

  unregister = () => {
    this.setState((state) => ({
      activityPopup: {
        open: true,
        msg: this.state.drone.is_registered ? "Deactivating drone, please Wait..." : "Activating drone, please Wait...",
        item: "WAIT",
        icon: "WAIT",
      }
    }), () => {
      API.updateGCSDrones(this.state.drone.drone_id, !this.state.drone.is_registered)
        .then((results) => {
          this.setState((prevState) => ({
            ...prevState,
            activityPopup: {
              open: true,
              msg: this.state.drone.is_registered ? "Drone deactivated successfully." : "Drone activated successfully.",
              item: "COMPLETE",
              icon: "COMPLETE",
            }
          }), () => {
            this.getDronesData()
          });
        })
        .catch((e) => {
          this.setState((state) => ({
            activityPopup: {
              open: true,
              msg: e.message || 'Error',
              item: "ERROR",
              icon: "ERROR",
            }
          }))
          try {
            console.log(JSON.stringify(e));
          } catch (exception) {
            console.log(e);
          }
        });
    })

  };

  componentWillUnmount() { updateOutTime(this.state.outId) }

  componentWillMount() {
    this.getPilotData()
    getActiveTeam().then(activeTeam => {
      this.setState({
        activeTeam: activeTeam
      }, () => {
        if (this.props.location.state.drone) {
          let cookiesData = cookies.get("drone_details");

          if (!cookiesData) {
            cookies.set('drone_details',
              JSON.stringify({ ...this.state.filter, droneId: this.props.location.state.drone.drone_id }),
              { path: "drone_management/drone_details" })
          }
          this.setState({ filter: cookiesData && cookiesData.droneId == this.props.location.state.drone.drone_id ? cookiesData : this.state.filter })

          document.title = "Drone Details - Management Services";
          let { user, type, drone } = this.props.location.state;
          getFeaturesPermissions([GCS_FEATURES.PLANS]).then(permissions => {
            addUserAnalytic(this.props.location.pathname).then(id => { this.setState({ outId: id }) })
            this.setState({
              user,
              type,
              drone,
              permissions,
            }, async () => {
              await this.getDronesData()
              await this.getFlightsData()
              const flightsStats = await API.getGCSFlightStats({ drones: [this.state.drone.drone_id] })
              this.setState({
                totalFlights: flightsStats.total_flights,
                totalAcreage: flightsStats.total_acres_covered,
                totalDistance: flightsStats.total_distance,
                loading: false,
              })
            });
          })
        } else {
          addUserAnalytic(this.props.location.pathname).then(id => { this.setState({ outId: id }) })
          window.location.replace("/login");
          return;
        }
      })
    })
  }

  updateDroneMaintenanceMode = async () => {
    try {
      const expected_return_date = this.state.isDroneMaintenanceModeEnablePopup.expected_return_date.toISOString().split("T")[0];
      const openMaintenanceLog = await API.updateDroneMaintenanceMode(this.state.drone.drone_id, this.state.isDroneMaintenanceModeEnablePopup ? true : false, this.state.isDroneMaintenanceModeEnablePopup?.reason, this.state.isDroneMaintenanceModeEnablePopup?.reason_description, this.state.isDroneMaintenanceModeEnablePopup?.date, null, expected_return_date)
      this.setState({
        isDroneMaintenanceModeEnablePopup: false,
        drone: {
          ...this.state.drone,
          is_in_maintenance: this.state.isDroneMaintenanceModeEnablePopup ? true : false,
          openMaintenanceLog: openMaintenanceLog.maintenanceModeLog || null
        },
        activityPopup: {
          open: true,
          msg: "Drone maintenance mode updated successfully.",
          item: "COMPLETE",
          icon: "COMPLETE",
        }
      })

    } catch (e) {
      console.error(e)
      this.setState({
        activityPopup: {
          open: true,
          msg: e.message || "Something went wrong while updating drone maintenance mode.",
          item: "ERROR",
          icon: "ERROR",
        }
      })
    }
  }

  getDronesData = async () => {
    try {
      this.setState({
        isLoading: true
      }, async () => {
        const result = await API.getGCSDrones({ droneId: this.state.drone.drone_id })
        result.drones.map((drone1, key) => {
          if (drone1.drone_id == this.state.drone.drone_id) {
            this.setState(state => ({
              ...state,
              selectedPilot: drone1.assigned_pilot,
              drone: drone1,
            }))
          }
        })
      })
    } catch (e) {
      console.error(e)
      this.setState({
        activityPopup: {
          open: true,
          msg: e.message || "Something went wrong while getting drone data.",
          item: "ERROR",
          icon: "ERROR",
        }
      })
    }
  }

  updateDroneUIN = async (droneId, droneUIN, teamId) => {
    try {
      if (this.state.Otp == '') {
        this.setState((state) => ({
          ...state,
          errorOtp: 'Please enter OTP'
        }))
        return
      }
      const result = await API.updateDroneUIN(droneId, droneUIN, this.state.Otp, teamId)
      if (otpInterval) clearInterval(otpInterval)
      this.setState(prev => ({
        ...prev,
        droneUINEditPopup: false,
        drone: {
          ...prev.drone,
          uin: droneUIN
        },
        droneUIN: '',
        Otp: '',
        otpTimerUIN: '',
        activityPopup: {
          open: true,
          msg: result.message || "Drone UIN updated successfully.",
          item: "COMPLETE",
          icon: "COMPLETE",
        },
        otpModal: false,
        otpSent: false
      }));


    } catch (e) {
      console.error(e)
      this.setState({
        otpTimerUIN: '',
        errorOtp: e.message,
        verifyOtpLoader: false
      })
    }
  }

  sendOtptoTeamOwner = async (OwnerId) => {
    try {
      this.setState(prev => ({
        ...prev,
        // resendOtp: false,
        deleteDroneOtpVerifyModal: false,
        showSendOTPbtn: false
      }));
      const result = await API.sendOtpToTeamOwner({ teamId: OwnerId, mobileOtp: this.state.sendOTPOnMobile })
      console.log(result)
      if (otpInterval) clearInterval(otpInterval);
      let timerData = result.remainTime
      let minutes = Number(timerData.split(':')[0])
      let seconds = Number(timerData.split(':')[1])
      otpInterval = setInterval(() => {
        let min = `0${minutes}`
        let sec = seconds < 10 ? `0${seconds}` : seconds
        this.setState((state) => ({
          ...state,
          otpTimerUIN: min < 1 ? `Resend OTP in ${min} : ${sec} sec` : `Resend OTP in ${min} : ${sec} min`
        }))
        seconds--;
        if (seconds < 0) {
          minutes--;
          seconds = 59;
          if (minutes < 0) {
            clearInterval(otpInterval);
            this.setState((state) => ({
              ...state,
              otpTimerUIN: ``,
              timeOutFlag: true
            }))
          }
        }
      }, 1000);
      this.setState(prev => ({
        ...prev,
        otpSent: true,
        showSendOTPbtn: true,
        resendOtp: false
      }));
    } catch (e) {
      console.error(e)
      this.setState({
        activityPopup: {
          open: true,
          msg: e.message || "Something went wrong while getting drone data.",
          item: "ERROR",
          icon: "ERROR",
        }
      })
    }
  }

  getPilotData = async () => {
    try {
      this.setState({
        isLoading: true
      }, async () => {
        const result = await API.getPilots()
        this.setState((prev) => ({ ...prev, pilots: result.dronePilots }))
      })
    }
    catch (e) {
      console.error(e)
      this.setState({
        activityPopup: {
          open: true,
          msg: e.message || "Something went wrong while getting Pilot data.",
          item: "ERROR",
          icon: "ERROR",
        }
      })
    }
  }

  getFlightsData = async () => {
    try {
      this.setState({
        isLoading: true
      }, async () => {
        cookies.set('drone_details', { ...this.state.filter, droneId: this.state.drone.drone_id }, { path: "drone_management/drone_details" })

        let { fromDateTime, toDateTime } = this.state.filter;
        const flights = await API.getGCSFlights({
          drones: [this.state.drone.drone_id], fromDateTime: fromDateTime ? new Date(fromDateTime).toISOString() : undefined, toDateTime: toDateTime ? new Date(toDateTime).toISOString() : undefined,
          orderBy: this.state.filter.orderBy, orderType: this.state.filter.orderType, pageSize: this.state.filter.pageSize, pageNumber: this.state.filter.pageNumber, projectName: undefined, planName: undefined
        })
        this.setState({ flights, isLoading: false })
      })
    }
    catch (e) {
      console.error(e)
      this.setState({
        activityPopup: {
          open: true,
          msg: e.message || 'Something went wrong while getting flights data.',
          item: "ERROR",
          icon: "ERROR",
        }
      })
    }
  }

  deleteFlight = async () => {
    try {
      this.setState({
        activityPopup: {
          open: true,
          msg: 'Deleting flight and related data please wait...',
          item: "WAIT",
          icon: "WAIT",
        }
      })
      const data = await API.deleteFlightData(this.state.deleteData.id)
      this.setState({
        deleteData: undefined,
        activityPopup: {
          open: true,
          msg: data.message,
          item: "COMPLETE",
          icon: "COMPLETE",
        }
      })
      this.getDronesData()
      this.getFlightsData()
      const flightsStats = await API.getGCSFlightStats({ drones: [this.state.drone.drone_id] })
      this.setState({
        totalFlights: flightsStats.total_flights,
        totalAcreage: flightsStats.total_acres_covered,
        totalDistance: flightsStats.total_distance,
      })
    }
    catch (e) {
      this.closeActivityPopup()
      Popup.alert("ERROR", e?.message || e)
    }
  }

  deleteDrone = () => {
    this.setState({
      activityPopup: {
        open: true,
        msg: "Deleting drone please wait...",
        item: "WAIT",
        icon: "WAIT",
      }
    }, () => {
      API.deleteDrone(this.state.drone.drone_id).then(async (result) => {
        let res = await result.json()
        if (result.status == 200) {
          this.setState({
            activityPopup: {
              open: true,
              msg: res.message,
              item: "COMPLETE",
              icon: "COMPLETE",
            }
          }, () => {
            setTimeout(() => {
              window.history.back()
            }, 1000)
          })
        } else if (result.status == 401) {
          this.setState({
            deleteFlightLogs: true,
            activityPopup: {
              open: true,
              msg: `This drone has ${res.flightCount} associated flights. Are you sure you want to delete them as well?`,
              item: "WARNING",
              icon: "WARNING",
            }
          })
        } else {
          this.setState({
            activityPopup: {
              open: true,
              msg: res.message || 'Error',
              item: "ERROR",
              icon: "ERROR",
            }
          })
        }
      }).catch((e) => {
        this.setState({
          activityPopup: {
            open: true,
            msg: e.message || 'Error',
            item: "ERROR",
            icon: "ERROR",
          }
        })
      })
    })
  }

  sendOtpForDeleteLogs = () => {
    API.sendOtpForDeleteLogs(this.state.drone.drone_id, this.state.sendOTPOnMobile).then(async (result) => {
      let res = await result.json()
      if (otpInterval) clearInterval(otpInterval);
      if (result.status == 200) {
        let timerData = res.remainTime
        let minutes = Number(timerData.split(':')[0])
        let seconds = Number(timerData.split(':')[1])
        otpInterval = setInterval(() => {
          let min = `0${minutes}`
          let sec = seconds < 10 ? `0${seconds}` : seconds
          this.setState((state) => ({
            ...state,
            otpTimer: min < 1 ? `Resend OTP in ${min} : ${sec} sec` : `Resend OTP in ${min} : ${sec} min`
          }))
          seconds--;
          if (seconds < 0) {
            minutes--;
            seconds = 59;
            if (minutes < 0) {
              clearInterval(otpInterval);
              this.setState((state) => ({
                ...state,
                otpTimer: ``,
                timeOutFlag: true
              }))
            }
          }
        }, 1000);
        this.setState({ activityPopup: undefined, droneDataDeleteOtpPopup: true, deleteDroneOtpVerifyModal: true, timeOutFlag: false, resend: false, deleteFlightLogs: false })
      } else {
        this.setState({
          activityPopup: {
            open: true,
            msg: res.message || 'Error',
            item: "ERROR",
            icon: "ERROR",
          }
        })
      }
    }).catch((e) => {
      this.setState({
        activityPopup: {
          open: true,
          msg: e.message || 'Error',
          item: "ERROR",
          icon: "ERROR",
        }
      })
    })
  }

  changeDronePilot = async (droneId, pilotId) => {
    try {
      await API.updateDronePilotAPI(droneId, pilotId).then((result) => {
        if (result.status === 200) {

          let getpilotName = this.state.pilots.find((pilot) => pilot.id === pilotId);

          this.setState((prev) => ({ ...prev, selectedPilotName: getpilotName.pilot_name }))
          Popup.alert("COMPLETE", "Pilot updated successfully.");
          // this.getDronesData();
        } else {
          Popup.alert("ERROR", "Failed to update pilot.");
        }
      })

    } catch (err) {

    }

  }

  verifyOtpAndDeleteDroneDataWithDrone = () => {
    this.setState({
      verifyOtpAndDeleteData: false,
      activityPopup: {
        open: true,
        msg: 'Deleting drone and all associated flights. please wait...',
        item: "WAIT",
        icon: "WAIT",
      }
    }, () => {
      API.verifyOtpAndDeleteDroneDataWithDrone(this.state.drone.drone_id, this.state.otp).then(async (result) => {
        let res = await result.json()
        if (otpInterval) clearInterval(otpInterval);
        if (result.status == 200) {
          this.setState({
            otpTimer: '',
            droneDataDeleteOtpPopup: false,
            activityPopup: {
              open: true,
              msg: 'The drone and all associated flights have been successfully deleted.',
              item: "COMPLETE",
              icon: "COMPLETE",
              close: () => { window.history.back() }
            }
          })
        } else {
          this.setState({
            otpTimer: '',
            activityPopup: undefined,
            errorOtp: res.message || 'Invalid OTP'
          })
        }
      }).catch((e) => {
        this.setState({
          otpTimer: '',
          activityPopup: undefined,
          errorOtp: e.message || 'Error verifying OTP'
        })
      })
    })
  }

  handleFilterChange = (newFilter, updatedField) => {
    const { fromDateTime, toDateTime } = newFilter;
    const isoFromDateTime = fromDateTime === undefined ? undefined : new Date(fromDateTime).toISOString();
    const isoToDateTime = toDateTime === undefined ? undefined : new Date(toDateTime).toISOString();
    this.setState({
      filter: {
        ...this.state.filter,
        ...newFilter,
        fromDateTime: fromDateTime === undefined || toDateTime === undefined ? undefined : isoFromDateTime,
        toDateTime: fromDateTime === undefined || toDateTime === undefined ? undefined : isoToDateTime,
      }
    }, () => {
      if (updatedField === "searchString") {
        this.setState({
          filter: {
            ...this.state.filter,
            pageNumber: 1,
          }
        }, () => { this.debounnceSearchFn(); })
      } else {
        this.getFlightsData();
      }
    });
  }

  render() {
    let { user, drone, } = this.state;
    const { activeProfile } = this.props;
    return user.username ? (
      <div className="wrapper">
        <div className="right-content-new" >
          <ActivityPopup
            item={this.state.activityPopup?.item}
            open={this.state.activityPopup?.open}
            icon={this.state.activityPopup?.icon}
            msg={this.state.activityPopup?.msg}
            close={this.state.activityPopup?.close || this.closeActivityPopup}
            onClickOk={this.state.activityPopup?.close || (() => {
              if (this.state.deleteData) {
                this.deleteFlight()
              } else if (this.state.verifyOtpAndDeleteData) {
                this.verifyOtpAndDeleteDroneDataWithDrone()
              } else if (this.state.deleteFlightLogs) {
                this.setState({
                  activityPopup: {
                    open: true,
                    msg: "Sending OTP to delete flights associated with this drone. Please wait...",
                    item: "WAIT",
                    icon: "WAIT",
                  }
                }, () => {
                  // this.sendOtpForDeleteLogs()
                  this.setState({
                    activityPopup: undefined,
                    deleteFlightLogs: false,
                    deleteDroneOtpVerifyModal: true,
                  })
                })
              } else if (this.state.drone.is_registered == false && this.state.droneDelete) {
                this.deleteDrone()
              } else {
                this.unregister()
              }
            })}
          />

          {/* Drone Maintenance mode enable popup */}
          <AnimatedModal
            isOpen={this.state.isDroneMaintenanceModeEnablePopup}
            height="auto"
            width="500px"
          >
            <div style={{ padding: "10px 20px", textAlign: 'left' }}>
              <div style={{ display: "flex", width: "inherit", fontSize: "20px", fontWeight: 600, fontFamily: "Lato", }}>{this.state.drone.drone_name} to Maintenance Mode</div>
              <div style={{ display: "flex", width: "inherit", padding: "20px 0px 10px 0" }}>
                <div>
                  <div className="droneDetailsViewHeadings">Date</div>
                  <div className="droneDetailsViewValues">{dateFormat(this.state.isDroneMaintenanceModeEnablePopup.date, 'dd/mm/yyyy')}</div>
                </div>
                <div style={{ marginLeft: "30px" }}>
                  <div className="droneDetailsViewHeadings">Time</div>
                  <div className="droneDetailsViewValues">{dateFormat(this.state.isDroneMaintenanceModeEnablePopup.date, 'hh:MM TT')}</div>
                </div>
                <div style={{ marginLeft: "30px" }}>
                  <div className="droneDetailsViewHeadings">Expected Return date</div>
                  <div className="dates__wrapper" style={{ cursor: 'auto', opacity: '1', marginTop: '5px', padding: '5px' }}>
                    <div style={{ cursor: 'auto', opacity: '1', gap: '10px' }} className="single__date" onClick={() => { this.setState({ datePicker: true }) }} >
                      <div style={{}} ><img src={Calender} style={{ width: '16px' }} /></div>
                      {this.state.isDroneMaintenanceModeEnablePopup?.expected_return_date !== undefined ?
                        <div className="date_time_wrapper">
                          <span style={{ fontSize: '16px' }}>{dateFormat(this.state.isDroneMaintenanceModeEnablePopup?.expected_return_date, "dd/mm/yyyy")}</span>
                        </div>
                        : <div className="undefined_date_wrapper" style={{ fontSize: '16px' }}>NA</div>}
                    </div>
                    <div className="react-datepicker-wrapper-custom-1" style={{ left: '70%' }}>
                      <DatePicker
                        showTimeSelect={false}
                        open={this.state.datePicker}
                        className="hidden"
                        selected={this.state.isDroneMaintenanceModeEnablePopup?.expected_return_date ? new Date(this.state.isDroneMaintenanceModeEnablePopup.expected_return_date) : null}
                        value={this.state.isDroneMaintenanceModeEnablePopup?.expected_return_date}
                        maxDate={new Date(new Date().setFullYear(new Date().getFullYear() + 1))}
                        minDate={new Date()}
                        onChange={(date) => {
                          this.setState((state) => ({
                            datePicker: false,
                            isDroneMaintenanceModeEnablePopup: {
                              ...state.isDroneMaintenanceModeEnablePopup,
                              expected_return_date: date
                            }
                          }))
                        }}
                        popperPlacement="bottom"
                        tetherConstraints={[]}
                        popperModifiers={[
                          {
                            name: "flip",
                            options: {
                              fallbackPlacements: ["bottom"],
                              allowedAutoPlacements: ["bottom"],
                            },
                          },
                        ]}
                        onClickOutside={() => { this.setState({ datePicker: false }) }}
                        placeholderText="Select a Expected Return date"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", width: "inherit", paddingTop: "10px" }}>
                <div>
                  <div className="droneDetailsViewHeadings">Select Reason</div>
                  <div style={{ display: "flex", gap: '25px', marginTop: '5px' }}>
                    <label style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: 16 }}>
                      <input type="radio" id="maintenanceMode" style={{ width: 16, height: 16 }}
                        value={this.state.isDroneMaintenanceModeEnablePopup.reason === 'repair'}
                        checked={this.state.isDroneMaintenanceModeEnablePopup.reason === 'repair'}
                        onChange={() => {
                          this.setState({
                            isDroneMaintenanceModeEnablePopup: {
                              ...this.state.isDroneMaintenanceModeEnablePopup,
                              reason: 'repair'
                            }
                          })
                        }}
                      />
                      Repair
                    </label>
                    <label style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: 16 }}>
                      <input type="radio" id="maintenanceMode" style={{ width: 16, height: 16 }}
                        value={this.state.isDroneMaintenanceModeEnablePopup.reason === 'replacement'}
                        checked={this.state.isDroneMaintenanceModeEnablePopup.reason === 'replacement'}
                        onChange={() => {
                          this.setState({
                            isDroneMaintenanceModeEnablePopup: {
                              ...this.state.isDroneMaintenanceModeEnablePopup,
                              reason: 'replacement'
                            }
                          })
                        }}
                      />
                      Replacement
                    </label>
                    <label style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: 16 }}>
                      <input type="radio" id="excludeFlights" style={{ width: 16, height: 16 }}
                        value={this.state.isDroneMaintenanceModeEnablePopup.reason === 'both'}
                        checked={this.state.isDroneMaintenanceModeEnablePopup.reason === 'both'}
                        onChange={() => {
                          this.setState({
                            isDroneMaintenanceModeEnablePopup: {
                              ...this.state.isDroneMaintenanceModeEnablePopup,
                              reason: 'both'
                            }
                          })
                        }}
                      />
                      Both
                    </label>
                  </div>
                </div>
              </div>
              <div className="add-user-form-text-wrapper">
                <textarea name="reason_description"
                  type="text" row="5" style={{ width: "100%", height: "100px", minHeight: '100px', maxHeight: '100px' }}
                  className="add-user-form-textArea"
                  placeholder="Please describe the reason..."
                  onChange={
                    (e) => {
                      const value = e.target.value.replace(/[^a-zA-Z0-9 .,()-]/g, ''); // Allow letters, numbers, space, dot, comma, parentheses, and hyphen only
                      this.setState((state) => ({
                        isDroneMaintenanceModeEnablePopup: {
                          ...state.isDroneMaintenanceModeEnablePopup,
                          reason_description: value
                        }
                      }))
                    }
                  }
                  value={this.state.isDroneMaintenanceModeEnablePopup.reason_description}
                  maxLength={150}
                  minLength={3}
                  required />
              </div>
              <div style={{ display: 'flex', justifyContent: "right", width: "inherit", margin: "20px -5px 10px 0" }}>
                <Button width={"20px"}
                  className={"new-btn-sm"}
                  text={"Cancel"}
                  onClick={() => {
                    this.setState({
                      isDroneMaintenanceModeEnablePopup: false,
                    })
                  }}
                />
                <Button
                  isDisabled={this.state.isDroneMaintenanceModeEnablePopup.reason_description?.length < 3 || !this.state.isDroneMaintenanceModeEnablePopup.reason || !this.state.isDroneMaintenanceModeEnablePopup.expected_return_date}
                  className={"new-btn-lg"}
                  text={"Put in Maintenance"}
                  type={"submit"}
                  isBtnActive={true}
                  onClick={() => {
                    this.updateDroneMaintenanceMode()
                  }}
                />
              </div>
            </div>
          </AnimatedModal>

          {/* Drone delete OTP send on Mobile/Email popup */}
          <AnimatedModal
            isOpen={this.state.deleteDroneOtpVerifyModal}
            height="250px"
            width="400px"
          >
            <div style={{ width: '100%', textAlign: 'center', fontSize: '16px', fontWeight: '500', marginTop: '25px' }}>Send OTP On</div>
            <hr style={{ width: '96%', color: 'grey', marginTop: '10px' }} />
            <div class="login-error" id="otpErrorMsg" style={{ height: '30px', fontSize: '14px', color: 'red', marginTop: '5px' }}>{this.state.errorOtp}</div>

            <div
              style={{
                textAlign: "left",
                lineHeight: "35px",
                margin: "-23px 35px",
                fontSize: "14px"
              }}
            >
              <input type="radio" checked={!this.state.sendOTPOnMobile} onChange={() => this.setState({ sendOTPOnMobile: false })} /> email {user.username}
              <br />
              {user.phone && user.phone != '-'?.slice(-4) && <>
                <input type="radio" checked={this.state.sendOTPOnMobile} onChange={() => this.setState({ sendOTPOnMobile: true })} /> mobile number +91 XXXXXX{user.phone.slice(-4)}
              </>}
            </div>
            <div style={{ textAlign: 'center', margin: '20px 35px' }}>
              <button type="button" className="loginUserButton" name="otpButton" id="otpButton"
                style={{ opacity: !this.state.showSendOTPbtn ? "0.5" : "", cursor: !this.state.showSendOTPbtn ? "not-allowed" : "pointer" }}
                onClick={() => { if (this.state.showSendOTPbtn) { this.sendOtpForDeleteLogs() } }}>{!this.state.showSendOTPbtn ? 'Sending OTP' : 'Send OTP'}
              </button>
            </div>
          </AnimatedModal>

          {/* drone and associated flight delete OTP accept popup */}
          <AnimatedModal
            isOpen={this.state.droneDataDeleteOtpPopup}
            height="350px"
            width="500px"
          >
            <div style={{ width: '100%', textAlign: 'center', fontSize: '16px', fontWeight: '500', marginTop: '25px' }}>Delete Drone</div>
            <img src={closeBtn} style={{ width: "12px", height: "12px", cursor: "pointer", top: "12px", right: '17px', position: 'absolute' }}
              onClick={() => {
                this.setState({
                  droneDataDeleteOtpPopup: false,
                  deleteDroneOtpVerifyModal: false,
                  otpTimer: '',

                })
                if (otpInterval) clearInterval(otpInterval);
                this.closeActivityPopup()
              }} />
            <hr style={{ width: '96%', color: 'grey', marginTop: '10px' }} />
            <div style={{ width: '100%', textAlign: 'center', lineHeight: '20px', marginTop: '10px', fontSize: '14px', fontWeight: '400', padding: '0px 20px' }}>An OTP to delete the drone-associated data has been sent to your registered email.</div>

            <div class="login-error" id="otpErrorMsg" style={{ height: '30px', fontSize: '14px', color: 'red', marginTop: '5px' }}>{this.state.errorOtp}</div>

            <div style={{ textAlign: 'center' }}>
              <img style={{ position: 'absolute', marginTop: '21px', marginLeft: '25px' }} src={lockIcon} />
              <input
                autoFocus
                class="text-input login-text-input" id="otp" style={{ width: '18rem' }} name="otp"
                type={this.state.showOtp ? "text" : "password"} onChange={(e) => {
                  this.setState({
                    errorOtp: '',
                    otp: e.target.value
                  })
                }}
                placeholder="OTP" maxlength="6" required />
              <img className="login-password-wrapper-img" id="view-password" style={{ cursor: 'pointer', top: '175px', left: '360px' }}
                src={this.state.showOtp ? eyeOffIcon : eyeIcon} onClick={() => {
                  this.setState({ showOtp: !this.state.showOtp })
                }} />
            </div>
            <div style={{ height: '25px', fontSize: '14px', marginTop: '10px' }}>{this.state.otpTimer}</div>

            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              {this.state.timeOutFlag === false ?
                this.state.otp ?
                  <button
                    type="button"
                    class="loginButton"
                    style={{
                      backgroundColor: "#e7000b",
                      opacity: this.state.errorOtp ? '0.5' : '1',
                      cursor: this.state.errorOtp ? 'not-allowed' : 'pointer'
                    }}
                    name="otpButton"
                    id="otpButton"
                    disabled={this.state.errorOtp}
                    onClick={() => {
                      if (!this.state.errorOtp) {
                        this.setState({
                          activityPopup: {
                            open: true,
                            msg: 'Deleting drone and all associated flights. please wait...',
                            item: "WAIT",
                            icon: "WAIT",
                          }
                        }, () => {
                          this.verifyOtpAndDeleteDroneDataWithDrone();
                        });
                      }
                    }}
                  >Delete Drone</button>
                  : <button type="button" class="loginButton" name="otpButton" id="otpButton" style={{ opacity: '0.5', cursor: 'not-allowed', backgroundColor: "#fb2c36" }}>Delete Drone</button>
                : <button type="button" style={{ opacity: this.state.resend ? '0.5' : '1', backgroundColor: "#e7000b" }} class="loginButton" name="resendButton" id="resendButton" disabled={this.state.resend}
                  onClick={() => {
                    this.setState({ resend: true })
                    this.sendOtpForDeleteLogs()
                  }}>Resend OTP</button>}
            </div>
          </AnimatedModal>

          {/* Drone UIN Edit popup*/}
          <AnimatedModal
            isOpen={this.state.droneUINEditPopup}
            height="auto"
            width="400px"
          >
            <div style={{ padding: "20px 10px" }}>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "inherit", fontSize: "20px", fontWeight: 600, fontFamily: "Lato", }}>Update UIN</div>
              <hr style={{ width: '96%', color: 'grey', marginTop: '10px' }} />
              <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", width: "inherit", padding: "10px 15px" }}>
                <div style={{ textAlign: "left", color: "#555C67", fontWeight: 500, marginBottom: "5px", fontSize: "small" }}>UIN Number</div>
                <input name="pilotMobile" className="teams-text-input" placeholder="Enter UIN Number" value={this.state.droneUIN}
                  maxLength={16} inputMode="text" pattern="[a-zA-Z0-9]*"
                  onInput={(event) => {
                    const value = event.target.value.replace(/[^a-zA-Z0-9]/g, '');
                    event.target.value = value;
                    this.setState((state) => ({
                      ...state,
                      droneUIN: value
                    }));
                  }}
                />
                <span style={{ fontSize: "10px", textAlign: "start", marginTop: "4px" }}>Click "Send" to trigger OTP to the Team owner.</span>
              </div>

              <div style={{ display: 'flex', justifyContent: "space-between", width: "inherit", marginTop: "10px", padding: "0 15px" }}>
                <Button width={"20px"}
                  className={"new-btn-sm"}
                  text={"Cancel"}
                  onClick={() => {
                    this.setState((state) => ({
                      ...state,
                      droneUINEditPopup: false,
                      droneUIN: "",
                      Otp: ""
                    }))
                  }}
                />
                <Button
                  isDisabled={this.state.droneUIN.length < 6 || drone.uin == this.state.droneUIN}
                  className={"new-btn-sm"}
                  text={"send"}
                  type={"submit"}
                  isBtnActive={true}
                  onClick={() => {
                    this.setState((prev) => ({ ...prev, otpModal: true, droneUINEditPopup: false }))
                  }}
                />
              </div>
            </div>
          </AnimatedModal>

          <AnimatedModal
            isOpen={this.state.otpModal}
            height="auto"
            width="400px"
          >
            <div style={{ width: '100%', textAlign: 'center', fontSize: '16px', fontWeight: '500', marginTop: '25px' }}>Update UIN</div>
            <img src={closeBtn} style={{ width: "12px", height: "12px", cursor: "pointer", top: "12px", right: '17px', position: 'absolute' }}
              onClick={() => {
                this.setState({
                  otpModal: false,
                  deleteDroneOtpVerifyModal: false,
                  otpTimerUIN: '',
                  droneUIN: "",
                  Otp: "",
                  droneUINEditPopup: false,
                  otpSent: false
                })
                if (otpInterval) clearInterval(otpInterval);
                this.closeActivityPopup()
              }} />
            <hr style={{ width: '96%', color: 'grey', marginTop: '10px' }} />
            {this.state.otpSent ? <div>
              <div style={{ width: '100%', textAlign: 'center', lineHeight: '20px', marginTop: '10px', fontSize: '14px', fontWeight: '400' }}>OTP has been sent to registered {this.state.sendOTPOnMobile ? "mobile number." : "email."}</div>
              <div style={{ textAlign: 'center' }}>
                <img style={{ position: 'absolute', marginTop: '21px', marginLeft: '25px' }} src={lockIcon} />
                <input autoFocus class="text-input login-text-input" id="otp" style={{ width: '18rem' }} name="otp" placeholder="OTP" maxlength="6"
                  type={this.state.showOtp ? "text" : "password"}
                  // onKeyDown={(e) => { if (e.key === 'Enter') this.verifyOtp(); }}
                  onChange={(e) => {
                    this.setState({
                      errorOtp: '',
                      Otp: e.target.value
                    })
                  }}
                  required />
                <img style={{ position: 'absolute', marginTop: '21px', marginLeft: '-45px' }}
                  src={this.state.showOtp ? eyeOffIcon : eyeIcon} onClick={() => { this.setState({ showOtp: !this.state.showOtp }) }} />
              </div>
              <div style={{ fontSize: '14px', marginTop: '10px' }}>{this.state.otpTimerUIN}</div>
              <div class="login-error" id="otpErrorMsg" style={{ fontSize: '14px', color: 'red', marginTop: '5px' }}>{this.state.errorOtp}</div>
              <div style={{ textAlign: 'center', margin: '5px 35px', paddingBottom: '10px' }}>
                {this.state.timeOutFlag === false && this.state.resendOtp === false ?
                  <button name="otpButton" id="otpButton" type="button" className="loginUserButton"
                    style={{ backgroundColor: "#e7000b", opacity: this.state.errorOtp ? "0.5" : "1", cursor: this.state.errorOtp ? "not-allowed" : "pointer" }}
                    disabled={this.state.errorOtp}
                    onClick={() => {
                      this.updateDroneUIN(drone.drone_id, this.state.droneUIN, activeProfile.activeTeamId)
                    }}>Update UIN</button>
                  : <button type="button" className="loginUserButton" name="resendButton" id="resendButton"
                    style={{ opacity: this.state.resendOtp ? "0.5" : "", cursor: this.state.resendOtp ? "not-allowed" : "pointer" }}
                    onClick={() => {
                      if (!this.state.resendOtp) {
                        this.setState({ resendOtp: true, timeOutFlag: false })
                        this.sendOtptoTeamOwner(activeProfile.activeTeamId)
                      }
                    }}>{this.state.resendOtp ? 'Resending OTP' : 'Resend OTP'}</button>}
              </div>
            </div>
              : <div>
                <div style={{ marginLeft: "35px" }}>
                  <div style={{ display: "flex", gap: "10px" }}>
                    <div style={{ textAlign: "left", color: "#555C67", marginBottom: "5px", }}>Previous UIN :</div>
                    <span>{drone.uin}</span>
                  </div>
                  <div style={{ display: "flex", gap: "10px" }}>
                    <div style={{ textAlign: "left", color: "#555C67", marginBottom: "5px", }}>Current UIN :</div>
                    <span>{this.state.droneUIN}</span>
                  </div>
                </div>
                <div style={{ textAlign: "left", lineHeight: "35px", margin: "5px 35px", fontSize: "14px" }}>
                  <div><input type="radio" checked={!this.state.sendOTPOnMobile} onChange={() => this.setState({ sendOTPOnMobile: false })} /> email {user.username}</div>
                  {user.phone && user.phone != '-' && user.phone?.slice(-4) && <div>
                    <input type="radio" checked={this.state.sendOTPOnMobile} onChange={() => this.setState({ sendOTPOnMobile: true })} /> mobile number +91 XXXXXX{user.phone.slice(-4)}
                  </div>}
                </div>
                <div class="login-error" id="otpErrorMsg" style={{ fontSize: '14px', color: 'red', marginTop: '5px' }}>{this.state.errorOtp}</div>
                <div style={{ textAlign: 'center', margin: '5px 35px', paddingBottom: '10px' }}>
                  <button type="button" className="loginUserButton" name="otpButton" id="otpButton"
                    style={{ opacity: !this.state.showSendOTPbtn ? "0.5" : "", cursor: !this.state.showSendOTPbtn ? "not-allowed" : "pointer" }}
                    onClick={() => { if (this.state.showSendOTPbtn) { this.sendOtptoTeamOwner(activeProfile.activeTeamId) } }}>{!this.state.showSendOTPbtn ? 'Sending OTP' : 'Send OTP'}</button>
                </div>
              </div>
            }
          </AnimatedModal>

          <div className="top-bar-new">
            <div className="top-bar-text-new">
              <BreadCrumbs
                data={[
                  {
                    displayName: "Home",
                    pathname: "/",
                    state: {
                      user
                    }
                  },
                  {
                    displayName: 'Drones',
                    pathname: "/aerogcsenterprise/drones",
                    state: {
                      user
                    }
                  },
                  {
                    displayName: 'Drone Details',
                  }
                ]} />
            </div>
          </div>
          <div className="main-content-new">
            {this.state.loading ? <LoaderComponent /> : <>
              <div className="droneDetailsView" style={{ marginTop: '15px', borderLeft: this.state.drone.is_in_maintenance ? '10px solid #DE9000' : '10px solid #3988F9' }}>
                <div>
                  <div style={{ display: 'flex', gap: "10px", alignItems: 'center' }}>
                    <div className="droneDetailsViewTitle" title={drone.drone_name || "-"}>{drone.drone_name ? drone.drone_name : "-"}</div>
                    <DroneErrorLogsBtn
                      linkState={{
                        drone: { drone_id: drone.drone_id, drone_name: drone.drone_name }
                      }}
                    />
                  </div>
                  {this.state.drone.is_in_maintenance && <div style={{ fontSize: '12px', color: '#DE9000' }}>{drone.drone_name ? drone.drone_name : "-"} is in maintenance mode</div>}
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "10px" }}>

                  <div className="add-user-form-row-left">
                  </div>
                  <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                      {'In Maintenance'}
                      <label className='toggle-label' style={{ marginBottom: '0px', position: "relative", zIndex: 1, }}>
                        <input className='toggle-input'
                          value={this.state.drone.is_in_maintenance}
                          type="checkbox"
                          checked={!!this.state.drone.is_in_maintenance}
                          onChange={(e) => {
                            e.stopPropagation();
                            if (e.target.checked) this.setState({
                              isDroneMaintenanceModeEnablePopup: {
                                date: new Date().toISOString(),
                                expected_return_date: new Date(new Date().setDate(new Date().getDate() + 1)),
                                reason_description: '',
                                reason: 'repair'
                              }
                            })
                            else {
                              this.props.history.push("/aerogcsenterprise/drone/hardwareDetails", { drone: this.state.drone, user: this.state.user, isUpdateAfterMaintenance: true, openMaintenanceLog: this.state.drone.openMaintenanceLog })
                            }
                          }}
                        />
                        <span className='toggle-span' onClick={(e) => { e.stopPropagation() }} />
                      </label>
                    </div>
                  </div>
                  <Button text={'Hardware Details'} isDisabled={this.state.user.subs.length == 0} className='new-btn-lg'
                    onClick={() => {
                      this.props.history.push("/aerogcsenterprise/drone/hardwareDetails", { drone: this.state.drone, user: this.state.user })
                    }} />
                  <Button text={'Health Report'} isDisabled={this.state.user.subs.length == 0} className='new-btn-lg'
                    onClick={() => {
                      this.props.history.push("/aerogcsenterprise/drone/drone_health_report", { drone: this.state.drone, user: this.state.user })
                    }} />
                  {this.state.activeTeam.isOwner && <div style={{ display: "flex" }}>
                    {/* <Button isBtnActive text={drone.is_registered ? 'Deactivate' : 'Activate'} isDisabled={this.state.user.subs.length == 0} className='new-btn-lg'
                      onClick={() => {
                        this.setState({
                          activityPopup: {
                            open: true,
                            msg: drone.is_registered ? 'Are you sure you want to deactivate this drone ?' : 'Are you sure you want to activate this drone ?',
                            item: "WARNING",
                            icon: "WARNING",
                          }
                        })
                      }} /> */}
                    {!drone.is_registered && <Button isBtnActive text={'Delete'} isDisabled={this.state.user.subs.length == 0} className='new-btn-lg'
                      onClick={() => {
                        this.setState({
                          droneDelete: true,
                          activityPopup: {
                            open: true,
                            msg: 'Are you sure you want to delete this drone ?',
                            item: "WARNING",
                            icon: "WARNING",
                          }
                        })
                      }} />}
                  </div>}
                </div>
              </div>

              <div className="droneDetailsViewContainer" style={{ marginTop: '15px' }}>
                {/* Basic Info */}
                <div className="droneDetailsViewData" style={{ width: '50%' }}>
                  <div className="droneDetailsViewSubTitle">Basic Info</div>
                  <div className="droneDetailsViewInfo">
                    <div style={{ width: '33%' }}>
                      <div className="droneDetailsViewHeadings" title="Drone Nam">Drone Name</div>
                      <div className="droneDetailsViewValues" title={drone.drone_name || "NA"}>{drone.drone_name || "NA"}</div>
                    </div>

                    <div style={{ width: '33%' }}>
                      <div className="droneDetailsViewHeadings" title="Drone UIN">Drone UIN <EditIcon
                        onClick={() => {
                          this.setState({ droneUINEditPopup: true, droneUIN: drone.uin || '' });
                        }}
                        style={{ cursor: 'pointer', fill: 'blue', width: '40px', height: '32px', marginLeft: '10px' }}
                      /></div>
                      <div className="droneDetailsViewValues" title={drone.uin || "NA"}>{drone.uin || "NA"}
                      </div>
                    </div>
                    <div style={{ width: '33%' }}>
                      <div className="droneDetailsViewHeadings" title="Registered Date">Registered Date</div>
                      <div className="droneDetailsViewValues" title={drone.registered_date ? dateFormat(drone.registered_date, "dd mmm yyyy") : "NA"}>{drone.registered_date ? dateFormat(drone.registered_date, "dd mmm yyyy") : "NA"}</div>
                    </div>
                  </div>
                  <div className="droneDetailsViewInfo">
                    <div style={{ width: '66%' }}>
                      <div className="droneDetailsViewHeadings" title="Drone ID">Drone ID</div>
                      <div className="droneDetailsViewValues" title={drone.drone_id || "NA"}>{drone.drone_id || "NA"}</div>
                    </div>
                    <div style={{ width: '33%' }}>
                      <div className="droneDetailsViewHeadings" title="Active Since">Active Since</div>
                      <div className="droneDetailsViewValues" title={drone.first_flight_date ? dateFormat(drone.first_flight_date, "dd mmm yyyy") : "N/A"}>{drone.first_flight_date ? dateFormat(drone.first_flight_date, "dd mmm yyyy") : "N/A"}</div>
                    </div>
                  </div>
                  <div className="droneDetailsViewInfo">
                    <div style={{ width: '33%' }}>
                      <div className="droneDetailsViewHeadings" title="Pilots Worked Under This Drone">Pilots Worked Under This Drone</div>
                      <div className="droneDetailsViewValues" title={drone.pilot_count || 0}>{drone.pilot_count || 0}</div>
                    </div>
                    <div style={{ width: '33%' }}>
                      <div className="droneDetailsViewHeadings" title="Status">Status</div>
                      <div className="droneDetailsViewValues" title={drone.is_registered ? 'Active' : 'Inactive' || 'NA'}>{drone.is_registered ? 'Active' : 'Inactive' || 'NA'}</div>
                    </div>
                    <div style={{ width: '33%' }}>
                      <div className="droneDetailsViewHeadings" title="License Type">Pilot Name</div>
                      <div className="Drones__Pilots__select">
                        <div className="pilots_wrapper">
                          <div style={{ width: "220px" }}>
                            <CreateSelect
                              allowCreate={false}
                              stopLoading={false}
                              options={this.state.pilots.map(pilot => ({ label: pilot.pilot_name, value: pilot.id }))}
                              value={this.state.selectedPilot ? { label: this.state.pilots.find(p => p.id === this.state.selectedPilot)?.pilot_name, value: this.state.selectedPilot } : null}
                              onChange={async (selected) => {
                                if (!selected) return;
                                this.setState(prev => ({ ...prev, selectedPilot: selected.value }));
                                Popup.alert("WARNING", "Are you sure you want to switch the pilot?", () => {
                                  this.changeDronePilot(drone.drone_id, selected.value);
                                }, () => { this.setState(prev => ({ ...prev, selectedPilot: drone?.assigned_pilot })); });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Flight summary */}
                <div className="droneDetailsViewData" style={{ width: '50%' }}>
                  <div className="droneDetailsViewSubTitle">Flight Summary</div>
                  <div className="droneDetailsViewInfo">
                    <div style={{ width: '33%' }}>
                      <div className="droneDetailsViewHeadings" title="Total Number of Hours">Total Number of Hours</div>
                      <div className="droneDetailsViewValues" title={getFlightTime(drone.total_flight_time) || "NA"}>{getFlightTime(drone.total_flight_time) || "NA"}</div>
                    </div>
                    <div style={{ width: '33%' }}>
                      <div className="droneDetailsViewHeadings" title="Total Number of flights">Total Number of flights</div>
                      <div className="droneDetailsViewValues" title={this.state.totalFlights || 0}>{this.state.totalFlights || 0}</div>
                    </div>
                    <div style={{ width: '33%' }}>
                      <div className="droneDetailsViewHeadings" title="Total Distance">Total Distance</div>
                      <div className="droneDetailsViewValues" title={this.state.totalDistance ? `${this.state.totalDistance} m` : "NA"}>{this.state.totalDistance ? `${this.state.totalDistance} m` : "NA"}</div>
                    </div>
                  </div>
                  <div className="droneDetailsViewInfo">
                    <div style={{ width: '33%' }}>
                      <div className="droneDetailsViewHeadings" title="Total Acreage">Total Acreage</div>
                      <div className="droneDetailsViewValues" title={this.state.totalAcreage ? `${(Number(this.state.totalAcreage) * 0.000247105).toFixed(6)} acre` : "-"}>{this.state.totalAcreage ? `${(Number(this.state.totalAcreage) * 0.000247105).toFixed(6)} acre` : "-"}</div>
                    </div>
                    <div style={{ width: '66%' }}>
                      <div className="droneDetailsViewHeadings" title="Last Coordinates">Last Coordinates</div>
                      <div className="droneDetailsViewValues" title={drone.latLng ? `${drone.latLng}` : 'NA'}>{drone.latLng ? `${drone.latLng}` : 'NA'}</div>
                    </div>
                  </div>
                  <div className="droneDetailsViewInfo">
                    <div style={{ width: '100%' }}>
                      <div className="droneDetailsViewHeadings" title="Last Location">Last Location</div>
                      <div className="droneDetailsViewValues" title={drone.location ? drone.location : "NA"}>{drone.location ? drone.location : "NA"}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="droneDetailsViewContainer" style={{ marginTop: '15px' }}>
                {/* Software Info */}
                <div className="droneDetailsViewData" style={{ width: '50%' }}>
                  <div className="droneDetailsViewSubTitle">Software Info</div>
                  <div className="droneDetailsViewInfo">
                    <div style={{ width: '33%' }}>
                      <div className="droneDetailsViewHeadings" title="AeroGCS Build Number">AeroGCS Build Number</div>
                      <div className="droneDetailsViewValues" title={drone.lastFlightBuild || drone.green_build_number || 'NA'}>{drone.lastFlightBuild || drone.green_build_number || 'NA'}</div>
                    </div>
                    <div style={{ width: '33%' }}>
                      <div className="droneDetailsViewHeadings" title="Android Version">Android Version</div>
                      <div className="droneDetailsViewValues" title={drone.android_version || 'NA'}>{drone.android_version || 'NA'}</div>
                    </div>
                    <div style={{ width: '33%' }}>
                      <div className="droneDetailsViewHeadings" title="Firmware Version">Firmware Version</div>
                      <div className="droneDetailsViewValues" title={drone.lastFlightFirmware || drone.firmware_version || 'NA'}>{drone.lastFlightFirmware || drone.firmware_version || 'NA'}</div>
                    </div>
                  </div>
                  <div className="droneDetailsViewInfo">
                    <div style={{ width: '33%' }}>
                      <div className="droneDetailsViewHeadings" title="License Type">License Type</div>
                      <div className="droneDetailsViewValues" title={drone.license_type || "NA"}>{drone.license_type || "NA"}</div>
                    </div>
                    <div style={{ width: '33%' }}>
                      <div className="droneDetailsViewHeadings" title="AeroGCS License Key">AeroGCS License Key</div>
                      <div className="droneDetailsViewValues" title={drone.license_id || 'NA'}>{drone.license_id || 'NA'}</div>
                    </div>
                    <div style={{ width: '33%' }} />
                  </div>
                </div>
                {/* Hardware Info */}
                <div className="droneDetailsViewData" style={{ width: '50%' }}>
                  <div className="droneDetailsViewSubTitle">Hardware Info</div>
                  <div className="droneDetailsViewInfo">
                    <div style={{ width: '33%' }}>
                      <div className="droneDetailsViewHeadings" title="Board Type">Board Type</div>
                      <div className="droneDetailsViewValues" title={drone.board_type || 'NA'}>{drone.board_type || 'NA'}</div>
                    </div>
                    <div style={{ width: '33%' }}>
                      <div className="droneDetailsViewHeadings" title="Device RAM">Device RAM</div>
                      <div className="droneDetailsViewValues" title={drone.device_ram || 'NA'}>{drone.device_ram || 'NA'}</div>
                    </div>
                    <div style={{ width: '33%' }}>
                      <div className="droneDetailsViewHeadings" title="Device Model Name">Device Model Name</div>
                      <div className="droneDetailsViewValues" title={drone.device_model_name || 'NA'}>{drone.device_model_name || 'NA'}</div>
                    </div>
                  </div>
                  <div className="droneDetailsViewInfo">
                    <div style={{ width: '66%' }}>
                      <div className="droneDetailsViewHeadings" title="GPS ID">GPS ID</div>
                      <div className="droneDetailsViewValues" title={drone.lastFlightGPSInfo ? JSON.parse(drone.lastFlightGPSInfo)?.gpsId : "NA"}>{drone.lastFlightGPSInfo ? JSON.parse(drone.lastFlightGPSInfo)?.gpsId : "NA"}</div>
                    </div>

                  </div>
                </div>
              </div>
              <div className="droneDetailsView" style={{ marginTop: '25px', width: `100%` }}>
                <div style={{ display: 'flex', gap: "10px", alignItems: 'center', width: '70%' }}>
                  <div className="reusable-table-title">{`Flights (${this.state.totalFlights || 0})`}</div>
                  <div style={{ display: "flex", gap: "5px", alignItems: "center", marginLeft: '15px' }}>
                    <div style={{ backgroundColor: '#1E90FF', height: '15px', width: '15px' }} />
                    <div>Synced: {drone.flight_count}</div>
                  </div>
                  <div style={{ display: "flex", gap: "5px", alignItems: "center", marginLeft: '15px' }}>
                    <div style={{ backgroundColor: '#FFA500', height: '15px', width: '15px' }} />
                    <div>Unsynced: {drone.offline_flights_count}</div>
                  </div>
                </div>
                {this.state.totalFlights != 0 && <Button isBtnActive
                  text={'View on map'}
                  className='new-btn-lg'
                  onClick={() => {
                    this.props.history.push('/aerogcsenterprise/user_flight_locations', {
                      user: this.state.user,
                      drone: this.state.drone
                    });
                  }}
                />}
              </div>
              <div className="drone-mgt-table-height" style={{ marginTop: '5px' }}>
                <TableView
                  isLoading={this.state.isLoading}
                  pageNumber={this.state.filter.pageNumber}
                  onStateChange={(changedState) => {

                    this.setState({ filter: { ...this.state.filter, ...changedState } }, () => {
                      this.getFlightsData()
                    })
                  }}
                  onClickRow={(flight) => {
                    delete flight.link_data;
                    delete flight.maintencance_icon
                    this.props.history.push('/aerogcsenterprise/flight_details', {
                      ...flight,
                      isOwner: this.state.activeTeam.isOwner,
                      drone: this.state.drone,
                      user: user,
                      flightId: flight.id,
                      planName: flight.plan_name,
                      projectName: flight.project_name,
                      date: flight.end_time,
                      startTime: flight.start_time,
                      end_time: flight.end_time,
                      streamKey: flight.streamkey,
                      areaCovered: flight.area_covered,
                      areaCoveredMethod: flight.area_calculation_method,
                      distanceCovered: flight.distance_covered,
                      droneId: flight.drone_id,
                      firmwareVersion: flight.firmware_version_number,
                      greenBuildNumber: flight.green_build_number,
                      droneName: flight.drone_name,
                      droneUIN: flight.uin,
                      software_edition: flight.software_edition
                    });
                  }}
                  columns={[
                    { Header: '', accessor: 'maintencance_icon', isSortable: false, isCenter: true, onHoverText: 'Drone is in maintenance' },
                    { Header: "Project/Plan Name", accessor: "projectPlanName", width: '21%' },
                    { Header: "Start/End Time", accessor: "flightDate", width: '21%', },
                    { Header: "Total Time", accessor: "total_flight_time", width: '12%', isSortable: true },
                    { Header: "Distance (M)", accessor: "distance_covered", width: '12%', isSortable: true },
                    { Header: "Sprayed Area (Acr)", accessor: "area_covered", width: '12%', isSortable: true },
                    { Header: "Consumed Liquid (ml)", accessor: "consumed_liquid", width: '12%', isSortable: true },
                    { Header: "Replay", accessor: "link_data", width: '5%', isIcon: true, isCenter: true },
                  ]}
                  count={this.state.totalFlights || 0}
                  data={this.state.flights?.map((flight) => {
                    return ({
                      ...flight,
                      maintencance_icon: flight.is_drone_in_maintenance ? <img style={{ width: "20px", height: '20px' }} src={InMaintenanceIcon} /> : undefined,
                      flightDate: `${dateFormat(flight.start_time, "dd/mm/yyyy hh:MM TT")} / ${dateFormat(flight.end_time, "hh:MM TT")}`,
                      projectPlanName: `${flight.project_name}/${flight.plan_name}`,
                      total_flight_time: getFlightTime(flight.total_flight_time),
                      area_covered: (Number(flight.area_covered) / 4046.85642).toFixed(4),
                      link_data: {
                        img: flightReplay,
                        onClick: (flight) => { this.props.history.push("/aerogcsenterprise/drone_control_center/fly_view", { flight: flight.id, user: this.state.user, replyData: 0 }) }
                      }
                    })
                  }) || []}
                  activities={this.state.activeTeam.isOwner && {
                    disableDelete: !this.state.permissions?.[GCS_FEATURES.PLANS]?.DELETE,
                    onClickDelete: (flight) => {
                      this.setState({
                        deleteData: flight,
                        activityPopup: {
                          open: true,
                          msg: 'Are you sure you want to delete selected flight and related data. (ie. streaming video, images, flight logs) ?',
                          item: "WARNING",
                          icon: "WARNING",
                        }
                      })
                    }
                  }}
                />
              </div>

            </>}

          </div>
        </div >
      </div >
    ) : (
      <div />
    );
  }
}

export default withRouter(connect(mapStateToProps)(DrnMgmtDroneDetails));